<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 shape-default shape-skew response bg-gradient">
        </div>
        <div class="pt-lg-md" style="width: 100%; padding: 0 100px 0 100px">
            <div class="row justify-content-center">
                <v-card style="display: flex; flex-direction: row; width: 100%" class="p-4">
                    <div style="flex: 1;">
                        <h4 class="multi-line font-weight-bold border-bottom">{{title}}</h4>
                        <span v-if="blog != null && blog.blog_content != null" class="html-content"
                              v-html="blog.blog_content"></span>
                        <p v-if="title != null" class="font-weight-bold mt-5">
                            {{language.lang("Share on social media:")}}
                            <ShareNetwork
                                    :title="title"
                                    :description="description"
                                    network="facebook"
                                    :url="currentPath"
                            >
                                <i class="fa fa-facebook m-2"></i>
                            </ShareNetwork>
                            <ShareNetwork
                                    :title="title"
                                    :description="description"
                                    network="twitter"
                                    :url="currentPath"
                            >
                                <i class="fa fa-twitter m-2"></i>
                            </ShareNetwork>
                            <ShareNetwork
                                    :title="title"
                                    :description="description"
                                    network="telegram"
                                    :url="currentPath"
                            >
                                <i class="fa fa-telegram m-2"></i>
                            </ShareNetwork>
                            <ShareNetwork
                                    :title="title"
                                    :description="description"
                                    network="linkedin"
                                    :url="currentPath"
                            >
                                <i class="fa fa-linkedin m-2"></i>
                            </ShareNetwork>
                            <ShareNetwork
                                    :title="title"
                                    :description="description"
                                    network="whatsapp"
                                    :url="currentPath"
                            >
                                <i class="fa fa-whatsapp m-2"></i>
                            </ShareNetwork>
                            <ShareNetwork
                                    :title="title"
                                    :description="description"
                                    network="instapaper"
                                    :url="currentPath"
                            >
                                <i class="fa fa-instagram m-2"></i>
                            </ShareNetwork>
                        </p>
                    </div>
                    <div :class="isEN ? 'ml-5' : 'mr-5'"
                         style="width: 1px; height: 100%; background-color: lightgray"></div>
                    <div class="ml-3 mr-2" style="width: auto; height: auto;">
                        <h5 class="ml-3 mr-3 font-weight-bold">{{language.lang("Top Articles:")}}</h5>
                        <div v-for="(item, index) in blogs" :key="index" class="m-3"
                             @click="$router.push({name: 'article', params: {id: item.blog_id}})">
                            <div v-ripple class="card shadow border-0">
                                <div style="width: 300Px;">
                                    <img style="width: 300Px; height: calc(300px * (9 / 16));" :src="item.blog_poster"
                                         class="card-img">
                                    <div class="p-2">
                                        <h6 class="">{{item.blog_title}}</h6>
                                        <span v-if="item.blog_brief != null && item.blog_brief.length > 0">{{item.blog_brief}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </div>
        </div>
    </section>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        name: "article",
        data: () => ({
            blogs: [],
            oracle: oracle,
            isEN: oracle.isEN(),
            language: language,
            currentPath: null,
            title: null,
            description: null,
            blog: null,
            id: null
        }), watch: {
            '$route': function (to, from) {
                this.getBlog()
            }
        }, methods: {
            getBlog() {
                if (this.id == null || this.id.length == 0) {
                    return
                }
                oracle.axios('blog/get', {"blog_id": this.id}, (response) => {
                    this.blog = response.data
                    this.title = this.blog.blog_title
                    this.description = this.blog.blog_description
                    document.title = 'Visternet | ' + this.title;
                })
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            this.currentPath = document.location.href
            oracle.axios('blog/getList', {order_by: 'priority', limit_by: 5}, (response) => {
                this.blogs = response.data
            })
            this.getBlog()
        }
    };
</script>
<style>
</style>
